import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Icon, Typography } from "@mui/material";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const BoostCampaignConfirmationThankyouPage = () => {
  return (
    <Box
      className="campaign-thankyou-page"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <div className="custom-thank-you-content text-center">
        <Icon
          component={RpSvgIcon}
          name="success_icon"
          color="primary"
          size="large"
          style={{ fontSize: "8.8rem" }}
        />
        <Typography color="text.primary" variant="h4" className="fw-b">
          You’re all set!
        </Typography>
        <Box className="d-flex align-items-center flex-column my-2 description-box">
          <Typography className="fw-sb description mt-4">
            Your adjusted budget is taking effect now within the dates selected.
          </Typography>
          <Typography className="fw-sb description mt-2 mb-5">
            Check your email for confirmation and additional details.
          </Typography>
        </Box>
        <Box className="d-flex-center my-1">
          <Button
            component={Link}
            to={`/dashboard`}
            className="thankyou-btn"
            variant="contained"
            color="primary"
            size="large"
          >
            Back to My Dashboard
          </Button>
        </Box>
      </div>
    </Box>
  );
};

export default BoostCampaignConfirmationThankyouPage;
